<template>
  <div class="industry_case">
    <div class="banner">
      <h1>Hardware Products</h1>
      <div class="inner_btn">
        <button @click="goToContact(2)" class="inner-le">Eco-cooperation</button>
        <button @click="goToContact(3)" class="inner-ri">Contact us</button>
      </div>
    </div>

    <div class="data_main">
      <div v-if="isMobile">
        <div v-for="group in hardwareGroupData" :key="group.typeId" class="hardware-type-group">
          <h2 class="hardware-type-name">{{ group.typeName }}</h2>
          <div class="hardware-grid">
            <div class="hardware-item" v-for="device in group.devices" :key="device.id" @click="goto_detail(device.id)">
              <img :src="device.thumbnail" alt="">
              <span class="hardware-item-name">{{ device.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-for="group in hardwareGroupData" :key="group.typeId" class="hardware-type-group">
          <h2 class="hardware-type-name">{{ group.typeName }}</h2>
          <el-row :gutter="20">
            <el-col :span="8" v-for="device in group.devices" :key="device.id">
              <div class="hardware-item" @click="goto_detail(device.id)">
                <img :src="device.thumbnail" alt="">
                <span class="hardware-item-name">{{ device.name }}</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup name="ProductHardCenterEN">
import { onMounted, onUnmounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { getDeviceTypePage } from '../api/deviceType';
import { getDevicePage } from '../api/device';

const router = useRouter();
const hardwareGroupData = ref([]);

onMounted(() => {
  window.scrollTo(0, 0);
  checkMobile();
  window.addEventListener('resize', checkMobile);
  renderPage();
});
onUnmounted(() => {
  window.removeEventListener('resize', checkMobile);
});

const emit = defineEmits(['scroll-to-contact']);
function goToContact(type) {
  emit('scroll-to-contact', type);
}

const isMobile = ref(false);
const checkMobile = () => {
  isMobile.value = window.innerWidth <= 1024;
};

async function renderPage() {
  const typeRes = await getDeviceTypePage({ appId: 2, pageSize: 1000, pageNum: 1 });
  const types = typeRes.data?.records || [];

  if (types.length) {
    const deviceResults = await Promise.all(
      types.map(type => getDevicePage({ appId: 2, deviceTypeId: type.id, pageSize: 1000, pageNum: 1 }))
    );
    hardwareGroupData.value = types
      .map((type, i) => ({
        typeId: type.id,
        typeName: type.name,
        devices: (deviceResults[i] && deviceResults[i].data?.records) ? deviceResults[i].data.records : []
      }))
      .filter(group => group.devices.length > 0);
  } else {
    hardwareGroupData.value = [];
  }
}

function goto_detail(id) {
  router.push(`/en/productharddetail?id=${id}`);
}
</script>

<style scoped>
.industry_case {
  width: 100%;
  height: 100%;
}

/* Banner styling with hardware product background */
.banner {
  overflow: hidden;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 12em;
  color: white;
  background-color: #ddd;
  margin-bottom: 4em;
  background-image: url('https://official-web-static.womucloud.com/bigBanner/pc/producthard.jpg');
  background-size: 100% 100%;
  background-position: center;
  text-align: left;
  background-repeat: no-repeat;
}
.inner_btn {
  margin-left: 18%;
  font-size: 0.8em;
}
.inner-le, .inner-ri {
  width: 10em;
  height: 3em;
  border-radius: 1.5em;
  font-size: 1em;
  border: transparent;
  cursor: pointer;
  margin: 1.5em auto;
}
.inner-le {
  background-color: orange;
  color: white;
  margin-right: 1em;
}
.inner-ri {
  background-color: skyblue;
  color: white;
}
.banner h1 {
  width: 65%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 1em;
  margin-left: 18%;
}

/* 硬件分组布局 */
.data_main {
  width: 60%;
  margin: 0 auto;
}
.hardware-type-group {
  margin-bottom: 3em;
}
.hardware-type-name {
  font-size: 1.1em;
  font-weight: 600;
  color: #323232;
  margin-bottom: 1em;
  padding-left: 0.5em;
  border-left: 3px solid #005BAC;
}
.hardware-item {
  text-align: center;
  cursor: pointer;
  margin-bottom: 1.5em;
  transition: transform 0.3s ease;
}
.hardware-item:hover {
  transform: translateY(-4px);
}
.hardware-item img {
  width: 100%;
  height: 10em;
  object-fit: contain;
  margin-bottom: 0.5em;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
.hardware-item-name {
  display: block;
  font-size: 0.9em;
  color: #323232;
  font-weight: 500;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Mobile responsive design */
@media (max-width: 1024px) {
  .banner {
    height: 15em;
    background-image: url('https://official-web-static.womucloud.com/bigBanner/m/producthard.jpg');
    margin-bottom: 1em;
    text-align: center;
  }
  .banner h1 {
    font-size: 1.2em;
    margin-top: 4em;
  }
  .inner_btn {
    margin-left: 0;
  }
  .inner-le, .inner-ri {
    font-size: 0.8em;
    height: 2.5em;
  }

  .data_main {
    width: 90%;
  }
  .hardware-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0.8em;
  }
  .hardware-grid .hardware-item img {
    height: 7em;
  }
  .hardware-grid .hardware-item-name {
    font-size: 0.75em;
  }
}
</style>
